/**
 * @file basic skan data
 */
import {
  moneyFormatterWithUnit,
  percentCellFormatter,
  integerValueFormatter,
} from 'src/const/statistics/formatters';
import store from 'src/store';

/**
   * 每项对应的字段
   * {
   *    key: 对应的后端字段
   *    i18nPath: title 文案对应的 key
   *    hint:
   *    hoverKey: 用于表头hover内容，绝大部分列的类型可以由key计算得来，特殊的列需要写死
   *    min-width: 最小宽度
   *    sortable: 是否可排序
   *    currency: ？？存在的意义是什么。发现没用先删掉了
   *    align: 对齐方向
   *    header-align: header 对齐方向
   *    formatter(Option): 数据格式化函数
   * }
   */
export const EnumBasicSkanData = [
  {
    i18nPath: 'list_skan_result', // 成效 (SKAN)
    key: 'skan_effect_cnt',
    hint: 'campaign_hover_stat_data.skan_result',
    hoverKey: 'campaign_hover_stat_data.skan_result',
    // 'min-width': COLUMN_WIDTH.L,
    sortable: true,
    align: 'right',
    'header-align': 'right',
    formatter: integerValueFormatter, // 格式化具体展示数据，千分位分隔+币种精度
    hide: () => !store.getters['dashboard/isDedicatedCampaignExist'],
  },
  {
    i18nPath: 'list_skan_per_cost', // 单次成效费用 (SKAN)
    hint: 'campaign_hover_stat_data.skan_per_cost',
    hoverKey: 'campaign_hover_stat_data.skan_per_cost',
    key: 'skan_effect_cost',
    // 'min-width': COLUMN_WIDTH.M,
    sortable: true,
    formatter: moneyFormatterWithUnit, // 单元格数据格式化
    hide: () => !store.getters['dashboard/isDedicatedCampaignExist'],
  },
  {
    i18nPath: 'list_skan_result_rate', // 成效率 (%) (SKAN)
    hint: 'campaign_hover_stat_data.skan_result_rate',
    hoverKey: 'campaign_hover_stat_data.skan_result_rate',
    key: 'skan_effect_rate',
    // 'min-width': COLUMN_WIDTH.S,
    sortable: true,
    formatter: percentCellFormatter,
    hide: () => !store.getters['dashboard/isDedicatedCampaignExist'],
  },
  {
    i18nPath: 'list_skan_conversion', // 转化数 (SKAN)
    // disabledText: 'campaign_hover_stat_data.cost_per_show_uv_mille.disabled',
    key: 'skan_convert_cnt',
    hint: 'campaign_hover_stat_data.skan_conversion',
    hoverKey: 'campaign_hover_stat_data.skan_conversion',
    sortable: true,
    formatter: integerValueFormatter,
    hide: () => !store.getters['dashboard/isDedicatedCampaignExist'],
  },
  {
    i18nPath: 'list_skan_cpa', // 转化成本 (SKAN)
    hint: 'campaign_hover_stat_data.skan_cpa',
    hoverKey: 'campaign_hover_stat_data.skan_cpa',
    key: 'skan_conversion_cost',
    sortable: true,
    formatter: moneyFormatterWithUnit,
    hide: () => !store.getters['dashboard/isDedicatedCampaignExist'],
  },
  {
    i18nPath: 'list_skan_cvr', // 成效率 (%) (SKAN)
    hint: 'campaign_hover_stat_data.skan_cvr',
    hoverKey: 'campaign_hover_stat_data.skan_cvr',
    key: 'skan_conversion_rate',
    // 'min-width': COLUMN_WIDTH.S,
    sortable: true,
    formatter: percentCellFormatter,
    hide: () => !store.getters['dashboard/isDedicatedCampaignExist'],
  },
];
